import { render, staticRenderFns } from "./paparanutama.vue?vue&type=template&id=601449a4&scoped=true"
import script from "./paparanutama.vue?vue&type=script&lang=js"
export * from "./paparanutama.vue?vue&type=script&lang=js"
import style0 from "./paparanutama.vue?vue&type=style&index=0&id=601449a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601449a4",
  null
  
)

export default component.exports